import React from 'react';
import { token } from '@atlaskit/tokens';

const primaryColor = token('color.icon');

const EmailIcon = () => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M6.66667 9.33341V22.6667H25.3333V9.33341H6.66667ZM25.3333 6.66675C26.8 6.66675 28 7.86675 28 9.33341V22.6667C28 24.1334 26.8 25.3334 25.3333 25.3334H6.66667C5.2 25.3334 4 24.1334 4 22.6667V9.33341C4 7.86675 5.2 6.66675 6.66667 6.66675H25.3333Z"
			fill={primaryColor}
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.33067 8.66675H4.16533C4.364 9.25341 4.69733 9.80541 5.16533 10.2734L13.008 18.1147C13.394 18.501 13.8523 18.8075 14.3567 19.0166C14.8612 19.2257 15.4019 19.3333 15.948 19.3333C16.4941 19.3333 17.0348 19.2257 17.5393 19.0166C18.0437 18.8075 18.502 18.501 18.888 18.1147L26.7307 10.2734C27.1973 9.80541 27.5307 9.25341 27.7293 8.66675H24.5653L17.0027 16.2294C16.8641 16.3681 16.6996 16.478 16.5185 16.5531C16.3374 16.6281 16.1433 16.6667 15.9473 16.6667C15.7513 16.6667 15.5572 16.6281 15.3762 16.5531C15.1951 16.478 15.0306 16.3681 14.892 16.2294L7.33067 8.66675Z"
			fill={primaryColor}
		/>
	</svg>
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => <EmailIcon />;
